export default "__VITE_ASSET__B6Fq1HdA__"